export const LOCAL_STORAGE_KEYS = {
  AUTHORIZATION_HEADER: 'X-Auth-Token',
  TC: 'tc',
  TC_TIME: 'tctime',
};